<template lang="html">
  <div class="spinner-container">
    <div :class="['half-circle-spinner', size]">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
    </div>
    <span class="spinner-message" v-if="message">{{message}}</span>
  </div>
</template>

<script>
export default {
  props: ['message', 'size']
}
</script>

<style lang="css">
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #afafaf;
}
.half-circle-spinner, .half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  position: relative;
}
.half-circle-spinner.small {
  width: 20px;
  height: 20px;
}
.spinner-message {
  display: block;
  margin-top: 10px;
}

.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(30px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: #abcff5;
  animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #abcff5;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);

  }
  100%{
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// Spinner.vue?ad87de88